import { render } from "./create_company.vue?vue&type=template&id=5d3fd10e&scoped=true"
import script from "./create_company.vue?vue&type=script&lang=js"
export * from "./create_company.vue?vue&type=script&lang=js"

import "./create_company.vue?vue&type=style&index=0&id=5d3fd10e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3fd10e"]])

export default __exports__